import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { sendWebVitalsToGa4 } from './utils/analytics';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { persistor, store } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <BrowserRouter>
  <PersistGate persistor={persistor}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </PersistGate>
  </BrowserRouter>
  </Provider>
);

// Called with no argument this was dead code: reportWebVitals() only loads the
// web-vitals bundle when it is handed a function. Core Web Vitals now reach GA4.
reportWebVitals(sendWebVitalsToGa4);
